import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "")
    .replace(/\$/g, "")
    .replace(/\s+/g, "")
    .replace(/^=/, "")
    .toUpperCase();
}

export async function gradeProject14(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Catálogo");
      const frozen = sheet.freezePanes.getLocationOrNullObject();
      frozen.load("address,rowCount");
      await context.sync();

      const passed =
        !frozen.isNullObject &&
        (frozen.rowCount === 3 || String(frozen.address).toUpperCase().includes("1:3"));
      results.push({ taskId: 1, passed });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Propiedad "Estado" del documento.
  // Se deja como revisión manual porque Office.js no expone de forma confiable
  // esta propiedad integrada del archivo en este proyecto.

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ventas T1");
      const printArea = sheet.pageLayout.getPrintAreaOrNullObject();
      printArea.load("address");
      await context.sync();

      const address = String(printArea.isNullObject ? "" : printArea.address)
        .replace(/\$/g, "")
        .toUpperCase();
      const passed = address.includes("A1:F17");
      results.push({ taskId: 3, passed });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ventas T1");
      const cell = sheet.getRange("B19");
      cell.load("formulas,values");
      await context.sync();

      const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
      const value = Number(cell.values[0][0]);
      const passed =
        (formula === "SUM(F4:F17)" || formula === "SUMA(F4:F17)") &&
        value === 251422;
      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ventas T1");
      const cell = sheet.getRange("B4");
      cell.load("formulas,values");
      await context.sync();

      const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
      const value = String(cell.values[0][0] ?? "").trim();
      const referencesCatalog =
        formula.includes("CATÁLOGO!D4".toUpperCase()) &&
        formula.includes("CATÁLOGO!C4".toUpperCase());
      const usesConcat = formula.includes("CONCAT") || formula.includes("&");
      const passed =
        referencesCatalog &&
        usesConcat &&
        value === "Campo traviesa - Rígida";
      results.push({ taskId: 5, passed });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
